import React from 'react'
import { useAddBoard } from '@ztechapps/board.webui'
import { Field, Form } from '@ztechapps/webui.form'
import { TextAreaInput, TextInput } from '@ztechapps/webui.input'
import { SaveCancelButtons } from '@ztechapps/webui.button'

export const AddBoardModalContent = () => {
  const { onSubmit, validate, onReset } = useAddBoard()

  return (
    <Form initialValues={{ name: 'Favorite name' }} onSubmit={onSubmit} onReset={onReset} validate={validate}>
      {({ isValid, isSubmitting }) => (
        <div className="flex-column d-flex justify-content-between   h-100 ">
          <div>
            <h3 className="text-center  ">Save to Your Favorites</h3>
            <hr />
            <Field component={TextInput} name={'name'} label="Name" placeholder="Favorite name" />
            <Field
              component={TextAreaInput}
              name={'remarks'}
              label="Remarks"
              help="Put some descriptive information about this board."
            />
          </div>

          <div className="d-flex justify-content-between   mt-4 ">
            <div />
            <SaveCancelButtons cancelType="reset" saveType="submit" isBusy={isSubmitting} disabled={!isValid} />
          </div>
        </div>
      )}
    </Form>
  )
}
